import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selected',
  pure: false,
})
export class SelectedPipe<T extends { selected: boolean }>
  implements PipeTransform
{
  transform(items: T[]): T[] {
    if (!items) {
      return items;
    }

    return items.filter((item) => item.selected);
  }
}
